/* eslint-disable camelcase */
import { apiConfig } from 'core-lib/config/config';
import { postMethod } from 'core-lib/utils/apiV2';
import { getDefaultHeaders } from 'core-lib/utils/network';
import { customToast } from 'core-lib/utils/customToast';

export interface AddressType {
  locality: string;
  city: string;
  state: string;
  landmark: string;
  address_type: number;
  secondary_address_type: string;
  pincode: string;
  email_id: string;
  latitude: any;
  longitude: any;
  user_address_meta: any;
  address: string;
  state_code: string;
}

export const saveNewAddress = async (data: AddressType) => {
  const endPoint = `${apiConfig('userNew')}/v1/user/address/update`;
  const { response, error }: any = await postMethod({
    endPoint,
    body: data,
    headers: getDefaultHeaders({ deviceId: true }),
  });
  if (response) {
    return { response: response };
  } else if (error) {
    customToast({
      label: error?.message || 'Something went wrong',
      variant: 'criticalNotPriority',
    });

    return { error: error };
  }
};
